import { MembroListaElettorale } from '@framework/api-client';
import { Datatype } from '@framework/engine';
import dayjs from 'dayjs';
import { CandidateColumns, ICandidateColumn } from '../table/CandidateColumns';

/**
 * Formatta il valore di una colonna in base al suo tipo
 */
const formatColumnValue = (value: any, column: ICandidateColumn): string => {
  if (value == null) return '';

  if (column.type === Datatype.Date) {
    return dayjs(value as string).format('DD/MM/YYYY');
  }
  if (column.type === Datatype.Boolean) {
    return value ? column.label : '';
  }
  return String(value);
};

/**
 * Genera la label per il candidato selezionato
 */
export const generateCandidateLabel = (
  candidate: MembroListaElettorale,
  labelColumns?: string[],
): string => {
  if (!labelColumns?.length) {
    // Default: nome cognome data di nascita
    const formattedDate = formatColumnValue(
      candidate.dataNascita,
      CandidateColumns.find(col => col.name === 'dataNascita')!,
    );
    return `${candidate.nome} ${candidate.cognome} ${formattedDate}`;
  }

  // Usa le colonne specificate
  return CandidateColumns.filter(col => labelColumns.includes(col.name))
    .map(col => formatColumnValue(candidate[col.name], col))
    .filter(val => val)
    .join(' ');
};
